import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { ExternalLink } from 'lucide-react';
import { cn } from '../lib/cn.js';
const textLinkVariants = cva('underline-offset-2 hover:underline', {
    variants: {
        tone: {
            /** Обычный цвет текста, жирнее соседей — ссылка-сущность в строке таблицы. */
            primary: 'font-medium text-[var(--color-text-primary)]',
            /** Приглушённая — служебная ссылка («← Все публикации»). */
            muted: 'text-[var(--color-text-muted)]',
            /** Цвет и вес — от родителя; только подчёркивание при наведении. */
            inherit: '',
        },
        /** Моноширинный короткий идентификатор: номер кейса, диалога. */
        mono: { true: 'font-mono text-xs', false: '' },
    },
    defaultVariants: { tone: 'primary', mono: false },
});
/**
 * Текстовая ссылка админки: подчёркивание при наведении поверх токенов цвета.
 *
 * Не `--color-brand-fg`: это цвет ПОВЕРХ фирменной заливки, на светлой
 * поверхности ссылка им исчезала. До выноса класс
 * `… underline-offset-2 hover:underline` был скопирован в «Контенте» трижды
 * и в чарджбеках, диалогах и комментариях — ещё пятью копиями.
 */
export const TextLink = React.forwardRef(({ asChild, external, tone, mono, className, children, ...props }, ref) => {
    if (asChild) {
        return (_jsx(Slot, { ref: ref, className: cn(textLinkVariants({ tone, mono }), className), ...props, children: children }));
    }
    if (external) {
        return (_jsxs("a", { ref: ref, target: "_blank", rel: "noreferrer noopener", className: cn('inline-flex items-center gap-1', textLinkVariants({ tone, mono }), className), ...props, children: [children, " ", _jsx(ExternalLink, { className: "h-3.5 w-3.5", "aria-hidden": "true" })] }));
    }
    return (_jsx("a", { ref: ref, className: cn(textLinkVariants({ tone, mono }), className), ...props, children: children }));
});
TextLink.displayName = 'TextLink';
//# sourceMappingURL=text-link.js.map